module.exports = __webpack_public_path__ + "img/Postmodernisme_Georg-Johannesen.492e61dc.jpg";